import { brand } from "services/envService";
import { YOUR_BOUNCE_BACK_LOAN } from "./SiteDown.const";

export const SiteDownPastRepaymentDateMessage = () => {
    document.title = YOUR_BOUNCE_BACK_LOAN;

    const envBrand = brand()?.toLowerCase();
    const brandMap: Record<string, string> = {
      nwb: "NatWest",
      rbs: "Royal Bank of Scotland",
      ubn: "Ulster Bank",
    };

    const brandText =
      brandMap[envBrand ?? ""] ??
      envBrand ??
      "bank";

    const SUPPORT_CENTRE_URLS: Record<string, string> = {
      nwb: "https://www.business.natwest.com/business/support-centre/workplace-wellbeing/struggling-financially.html",
      rbs: "https://www.rbs.co.uk/business/support-centre/workplace-wellbeing/struggling-financially.html#contact",
      ubn: "https://www.ulsterbank.co.uk/business/support/workplace-wellbeing/struggling-financially.html",
    };

    return (
    <div>
    <p>
      Unfortunately we are unable to progress your Pay As You Grow (PAYG) request.
      Your Bounce Back Loan has passed its final repayment date, which means PAYG options are no longer available.
    </p>
    <br />
    <p>
      If you’re struggling to make repayments or experiencing financial difficulty, we’re here to help.
      You can find guidance on the support we offer on our {" "}
      <a
        href={SUPPORT_CENTRE_URLS[envBrand]} rel="noreferrer" target="_blank">
        website
        </a> or speak to your usual {brandText} contact.
      This page also lists independent organisations that provide impartial advice to businesses facing financial challenges.
    </p>
    </div>
    );
};